import $ from './app/jquery-shim.js';
import "core-js";
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';

import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";
import "./app/chart";


class ScrollReveal {
  constructor(options) {
    this.options = options;
  }

  reveal(el, options, duration) {
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire(el, function () {
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options, args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }


      //concept-hero-slide
      owls.imagesLoaded(function () {
        $('.c-hero-slide__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              autoWidth: false,
            },
          }
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-card-slider').find('.c-card__block').length < 3) {
          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });

      owls.imagesLoaded(function () {
        $('.js-interview-slider').owlCarousel({
          margin: 0,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/assets/images/icon-slider-prev.svg" />', '<img src="/assets/images/icon-slider-next.svg" />'],
          items: 1,
          smartSpeed: 800
        });
      });

      owls.imagesLoaded(function () {
        $('.js-banner-slider').owlCarousel({
          margin: 32,
          dots: true,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<span class="is-prev"></span>', '<span class="is-next"></span>'],
          items: 3,
          smartSpeed: 500,
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1
            },
            750: {
              items: 2,
              center: false,
              margin: 10
            },
            // breakpoint from 750 up
            950: {
              items: 3,
            }
          }
        });
      });
    }

    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-main-visual,.l-page-header", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-solution__wrap  > *", {
        scale: [0.9, 1],
        opacity: 1,
        duration: 600,
        delay: anime.stagger(100),
        translateX: [-baseDistance, 0],
        easing: baseEasing
      });
      domEach(".c-card-sm__block", function (key, item) {

        sr.reveal(item, {
          scale: {
            value: [0.9, 1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100 * key,
          translateY: [-baseDistance, 0],
          easing: baseEasing
        });
      });
    }


    //
    // function tabSlickSlider() {
    //
    //
    //   const $gallery = $(".c-tabs__content.is-active");
    //
    //   if ($gallery.find('.c-tabs__slider').length <= 0 || $gallery.find('.c-tabs__thumbnail').length <= 0){
    //     return false;
    //   }
    //
    //   if ($gallery.find(".c-tabs__thumbnail .c-tabs__thumbnail-box").length < 2) {
    //     $gallery.find(".c-tabs__thumbnail").addClass("is-simple-none");
    //   }
    //
    //   const num = $gallery.data("tabName") + 1;
    //
    //
    //   let currentNum = $gallery.find('.c-tabs__paging .is-current');
    //   let lengthNum = $gallery.find('.c-tabs__paging .is-length');
    //
    //   $gallery.find(`.c-tabs__slider`).not('.slick-initialized').on('init', function (event, slick) {
    //     currentNum.text(slick.currentSlide + 1);
    //     lengthNum.text(slick.slideCount);
    //   }).slick({
    //     infinite: true,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     autoplay: true,
    //     asNavFor: `.c-tabs__thumbnail.is-thumbnail-${num}`,
    //   }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    //     currentNum.text(nextSlide+1);
    //   })
    //
    //   const thumbnailNum = $gallery.find(`.c-tabs__thumbnail-box`).length;
    //
    //   if (thumbnailNum > 4) {
    //     $gallery.find(`.c-tabs__thumbnail`).removeClass("is-stick");
    //     $gallery.find(`.c-tabs__thumbnail-arrows`).addClass("is-hidden");
    //   }
    //
    //   // 下段
    //   $gallery.find(`.c-tabs__thumbnail`).not('.slick-initialized').slick({
    //     infinite: true,
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     margin: 12,
    //     asNavFor: `.c-tabs__slider.is-slider-${num}`,
    //     focusOnSelect: true,
    //     prevArrow:"<img class='is-prev' src='../assets/images/icon-slider-prev.svg'/>",
    //     nextArrow:"<img class='is-next' src='../assets/images/icon-slider-next.svg'/>",
    //     arrows: true
    //   });
    //
    //
    //   if (thumbnailNum <= 4) {
    //     const arrows = $gallery.find(`.c-tabs__thumbnail-arrow`);
    //     arrows.click(function (e) {
    //       if (e.target.classList.contains("is-next")) {
    //         $gallery.find(`.c-tabs__slider`).slick('slickNext');
    //       } else if (e.target.classList.contains("is-prev")) {
    //         $gallery.find(`.c-tabs__slider`).slick('slickPrev');
    //       }
    //     })
    //   }
    //
    // }
    // slick
    function slickSlider() {

      if ($('.c-main-visual__slider').length < 0) {
        return false;
      }

      if ($('.c-main-visual__thumbnail .c-main-visual__thumbnail-image').length < 2) {
        $(".c-main-visual__thumbnail").addClass("is-simple-none");
      }

      if (window.innerWidth >= 751) {
        $('.c-main-visual__slide').clone().prependTo('.c-main-visual__slider');
        $('.c-main-visual__thumbnail-image').clone().prependTo('.c-main-visual__thumbnail');
      }

      $('.c-main-visual__slider').on('init', function(event, slick){
        scrollAnim();
      });

      // 上段
      $('.c-main-visual__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.c-main-visual__thumbnail',
        autoplaySpeed: 5000,
        speed: 1000,
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 0,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1,
            stagePadding: 0,
          },
        }]
      });


      // 下段
      $('.c-main-visual__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
        arrows: true,
        dots: true,
        infinite: true,
        center: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.c-main-visual__slider',
        focusOnSelect: true,
        prevArrow: "<div class='is-prev'><img src='../assets/images/icon-slider-prev.svg'/></div>",
        nextArrow: "<div class='is-next'><img src='../assets/images/icon-slider-next.svg'/></div>",
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '27.2%',
          }
        }]
      });

      /*======　物件詳細 ギャラリー ======*/
      const slider = '.js-gallery-slider';
      const sliderMain = '.js-gallery-slider-main';
      const thumbItemClassName = '.js-gallery-item-thumb';

      $(slider).each(function (i, e) {
        if ($(e).find(thumbItemClassName).length < 2) {
          $(e).addClass("is-simple-none");
        }

        $(e).find(thumbItemClassName).each(function (i, elem) {
          $(elem).attr("data-index", i);
        });

        $(e).find(sliderMain).on('init', function (slick) {
          // console.log($(e).find(".slick-slide.slick-current").attr("data-slick-index"));
          var index = $(e).find(".slick-slide.slick-current").attr("data-slick-index");
          $(thumbItemClassName + '[data-index="' + index + '"]').addClass("is-current");
        });

        //slickスライダー初期化
        $(e).find(sliderMain).slick({
          fade: false,
          accessibility: true,
          autoplay: true,
          autoplaySpeed: 5000,
          speed: 1000,
          arrows: true,
          dots: false,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
          prevArrow: "<div class='is-prev'><img src='/assets/images/icon-slider-prev.svg'/></div>",
          nextArrow: "<div class='is-next'><img src='/assets/images/icon-slider-next.svg'/></div>",
          responsive: [{
            breakpoint: 0,
            settings: {
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: 1,
              centerMode: true,
            }
          }]
        });

        $(e).find(thumbItemClassName).on('click', function () {
          var index = $(this).attr("data-index");
          $(e).find(sliderMain).slick("slickGoTo", index, false);
        });

        $(e).find(sliderMain).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          $(e).find(thumbItemClassName).each(function (i, elem) {
            $(elem).removeClass("is-current");
          });
          $(e).find(thumbItemClassName + '[data-index="' + nextSlide + '"]').addClass("is-current");
        });
      });

      // 物件詳細のタイトル下の画像をスライダーにする
      const $productsHeadSlider = $(".js-products-head-slider");
      if($productsHeadSlider){
        $productsHeadSlider.slick({
          fade: false,
          accessibility: true,
          autoplay: false,
          autoplaySpeed: 5000,
          speed: 1000,
          arrows: true,
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          focusOnSelect: true,
          prevArrow: "<div class='is-prev'><img src='/assets/images/icon-slider-prev.svg'/></div>",
          nextArrow: "<div class='is-next'><img src='/assets/images/icon-slider-next.svg'/></div>",
          responsive: [{
            breakpoint: 0,
            settings: {
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: 1,
              centerMode: true,
            }
          }]
        })
      }
    }

    // ループスライダー
    function infiniteSlider() {
      const optionInfinite = {
        infinite: true,
        arrows: false,
        swipe: false,
        dots: false,
        variableWidth: true,  // スライド幅の自動計算を無効
        autoplay: true,
        autoplaySpeed: 0,
        speed: 10000,
        cssEase: "linear",
        pauseOnFocus: false,
        pauseOnHover: false
      }
      const slickInfinite = $('.js-infinite-slider');
      if (slickInfinite) $(slickInfinite).slick(optionInfinite);
    }


    function continueBox() {
      const btn = '.js-continue-btn';
      const target = '.js-continue-box';

      $(btn).on('click', function () {

        console.log($(this));
        if ($(target).hasClass("is-open")) {
          $(target).removeClass('is-open');
          // console.log()
          $(this).removeClass("is-open");
          $(this).text("続きを読む");
        } else {
          $(target).addClass('is-open');
          // console.log()
          $(this).addClass("is-open");
          $(this).text("折りたたむ");
        }
      });
    }


    function InterSectionToC() {
      const targets = document.querySelectorAll("section");
      var lastScrollTop = 0;
      var  currentScrollTop = 0;

      const options = {
        root: null, // 今回はビューポートをルート要素とする
        rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
        threshold: 0 // 閾値は0
      };

      if (targets.length <= 0) return;

      const observer = new IntersectionObserver(doWhenIntersect, options);
      // それぞれのboxを監視する
      for (let i = 0; i < targets.length; i++) {
        // targets.forEach(target => {
          observer.observe(targets[i]);
        // });
      }

      /**
       * 交差したときに呼び出す関数
       * @param entries
       */
      function doWhenIntersect(entries) {
        // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
        for (let i = 0; i < entries.length; i++) {
          // observer.observe(entries[i]);
          if (entries[i].isIntersecting) {
            activateIndex(entries[i].target);
          }
        }
        // entries.forEach(entry => {
        //   if (entry.isIntersecting) {
        //     activateIndex(entry.target);
        //   }
        // });
      }

      /**
       * 目次の色を変える関数
       * @param element
       */
      function activateIndex(element) {
        // すでにアクティブになっている目次を選択
        const currentActiveIndex = document.querySelector("#js-nav-index li a.is-active");
        // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
        if (currentActiveIndex !== null) {

          currentActiveIndex.classList.remove("is-active");

          currentScrollTop = window.pageYOffset + document.querySelector(".c-anchor-page-nav__navs").getBoundingClientRect().top;


          if (currentScrollTop > lastScrollTop){
            // downscroll code

            lastScrollTop = currentScrollTop;
            const prevEleWidth = currentActiveIndex.offsetWidth;
            document.querySelector(".c-anchor-page-nav__navs").scrollLeft += prevEleWidth;

          } else {

            lastScrollTop = currentScrollTop;
            const currentNode = document.querySelector(`a[href='#${element.id}']`);
            if (currentNode.parentElement.previousElementSibling) {
              let prevSibling = currentNode.parentElement.previousElementSibling.offsetWidth;
              document.querySelector(".c-anchor-page-nav__navs").scrollLeft -= prevSibling;
            } else {
              document.querySelector(".c-anchor-page-nav__navs").scrollLeft = 0;
            }

          }
          // lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        }

        // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
        const newActiveIndex = document.querySelector(`a[href='#${element.id}']`);
        if (newActiveIndex) {
          newActiveIndex.classList.add("is-active");
        }



      }
    }

    function fixedHeader() {

      const header = document.getElementById('js-nav-index');
      const observerHeader = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            header.classList.remove('is-fixed');
          } else {
            header.classList.add('is-fixed');
          }
        }
      });

      const headEle = document.getElementById('head');

      if (!headEle) return;

      observerHeader.observe(headEle);
    }

    function getQueryString() {
      var key = false, res = {}, itm = null;
      // get the query string without the ?
      var qs = location.search.substring(1);
      // check for the key as an argument
      if (arguments.length > 0 && arguments[0].length > 1)
        key = arguments[0];
      // make a regex pattern to grab key/value
      var pattern = /([^&=]+)=([^&]*)/g;
      // loop the items in the query string, either
      // find a match to the argument, or build an object
      // with key/value pairs
      while (itm = pattern.exec(qs)) {
        if (key !== false && decodeURIComponent(itm[1]) === key)
          return decodeURIComponent(itm[2]);
        else if (key === false)
          res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
      }

      return key === false ? res : null;
    }

    function changeTab() {

      // const url = new URL(window.location.href);
      const tabNum = getQueryString("target");
      // url.searchParams.get("content");

      if (!tabNum || tabNum !== "map") return;

      const nav = $(".c-tabs__navs");
      const contents = $(".c-tabs__content");

      if (!nav.length || !contents.length) return;

      const list = nav.find("li a");
      list.removeClass("is-active");
      for (let i = 0; i < list.length; i++) {
        const target = list[i].getAttribute('data-tab-target');
        if (target === "map") {
          list[i].classList.add("is-active");
        }
      }

      contents.removeClass("is-active");
      for (let i = 0; i < contents.length; i++) {
        const targetContent = contents[i].getAttribute('data-tab-name');
        if (targetContent === "map") {
          contents[i].classList.add("is-active");
        }
      }


    }

    function toggleFavoriteBtn() {
      const buttons = document.querySelectorAll(".js-favorite-btn");
      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];
        button.addEventListener("click", function (e) {
          e.preventDefault();
          const targetEle = e.currentTarget;
          targetEle.classList.toggle("is-active");
          return false;
        })
      }
    }

    function scrollAnim() {
      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-block-top-concept",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".js-popup",
          {
            opacity: 0,
            y: 20,
            delay: 0.3,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )

      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-card-houses__content.is-top",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-card-houses__block",
          {
            opacity: 0,
            y: 20,
            delay: 0.4,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )

      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-card-interview.is-front",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-card-interview__list",
          {
            opacity: 0,
            y: 20,
            delay: 0.4,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )

      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-card-blog__list.is-top",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-card-blog__item.is-top",
          {
            opacity: 0,
            y: 20,
            delay: 0.4,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )

      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-box-slip.is-top",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-box-slip__item",
          {
            opacity: 0,
            y: 20,
            delay: 0.4,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )

      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-news.is-front",
            start: "top 70%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-news__item",
          {
            opacity: 0,
            y: 20,
            delay: 0.4,
            duration: .5,
            stagger: {
              from: "start",
              each: .2,
            }
          }
        )
      // gsap
      //   .timeline({
      //     defaults: {},
      //     scrollTrigger: {
      //       trigger: ".c-card-blog",
      //       start: "top 70%",
      //       toggleActions: "play none none none",
      //     },
      //   })
      //   .from(".c-card-blog__item",
      //     {
      //       opacity: 0,
      //       y: 20,
      //       delay: 0.4,
      //       duration: .5,
      //       stagger: {
      //         from: "start",
      //         each: .2,
      //       }
      //     }
      //   )
    }

    function fadeInMainVisual() {
      gsap
        .timeline({
          defaults: {},
          scrollTrigger: {
            trigger: ".c-main-visual__slider",
            start: "top 100%",
            toggleActions: "play none none none",
          },
        })
        .from(".c-main-visual__slider",
          {
            opacity: 0,
            delay: 0,
            duration: 1,
          }
        )
    }

    function setScrollPosX() {

    }

    $(function () {

      menuSlide();
      owlCarousel();
      reveal();
      slickSlider();
      infiniteSlider();
      continueBox();
      InterSectionToC();
      fixedHeader();
      changeTab();
      toggleFavoriteBtn();
      // setScrollPosX();
    });
  }
}

window.GApp = new App();
